import React, { SVGProps } from 'react';

/* eslint-disable max-len */
const SvgCheckmark: React.FunctionComponent<SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 40 28" {...props}>
    <g transform="translate(-22 -29)" fillRule="evenodd">
      <rect transform="rotate(-42 46.91 42.91)" x={27.91} y={39.41} width={38} height={7} rx={3.5} />
      <path d="M28.28 42.34l8.92 8.03a3.5 3.5 0 01-4.68 5.2l-8.92-8.03a3.5 3.5 0 114.68-5.2z" />
    </g>
  </svg>
);
/* eslint-enable max-len */

export default SvgCheckmark;
